<template>
  <MitikuinSecccionOne />
  <div class="landing-wrap">
    <!-- CONTENIDO PRINCIPAL -->
    <section class="container py-5" id="paquetes">
      <h2 class="fw-bold mb-3 text-center heading-glow">Servicios y Paquetes</h2>
      <p class="lead text-center mb-5 intro-text">Tres planes pensados para cada etapa:  presencia en línea hasta
        plataformas con seguridad y automatización.</p>

      <div class="row g-4 row-cols-1 row-cols-md- row-cols-lg-3">
        <div v-for="(p, i) in paquetes" :key="i">
          <div class="card h-100 shadow-sm card-glass">
            <div class="card h-100 shadow-sm card-glass card-body d-flex flex-column card-electric text-start">
              <img src="/assets/img/logo_mitikuinRedondeado.webp" class="img-fluid my-3 ms-auto d-block mockupdown1"
                alt="Logo Mitikuin" width="40" height="40" />
              <div class="d-flex align-items-start justify-content-between mb-2 titlepaq">
                <h2 class="card-title mb-0 intro-text1">{{ p.nombre }} </h2>
                <i class="bi bi-stars text-info fs-5"></i>
              </div>
              <p class="card-subtitle1 mb-2 tagline">{{ p.tagline }}</p>
              <p class="d-flex align-items-start mb-2 featurestitle">{{ p.featurestitle }}</p>
              <ul class="list-unstyled small mt-3 flex-grow-1 intro-text">
                <li v-for="(f, idx) in p.features" :key="idx" class="feature-item d-flex align-items-start mb-2">
                  <span class="icon-wrapper me-2">
                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" class="check-icon">
                      <path fill="currentColor"
                        d="M11.102 7.37a.75.75 0 1 0-1.06-1.06L7.54 8.81 6.508 7.78a.75.75 0 0 0-1.06 1.06l1.407 1.408a.968.968 0 0 0 1.37 0l2.877-2.878Z">
                      </path>
                      <path fill="currentColor" fill-rule="evenodd"
                        d="M15 7.995a7 7 0 1 1-14 0 7 7 0 0 1 14 0Zm-1.5 0a5.5 5.5 0 1 1-11 0 5.5 5.5 0 0 1 11 0Z"
                        clip-rule="evenodd"></path>
                    </svg>
                  </span>
                  <span class="feature-text" v-html="f"></span>
                </li>
              </ul>
              <p class="d-flex align-items-start mb-2 featurestitle">{{ p.caracteristicas }}</p>

              <div class="mt-3 fw-bold price fontsatoshi row mb-3">
                <div class="col-3 text-start">
                  <span class="textdescription"></span>
                </div>
                <div class="col-9 text-center">
                  <span class="textdescription2">{{ p.precio }}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>    
    
    <!-- CTA final -->
    <MitiWhatsapp />
    <MitiPortfolio />
    <MitiFooter />
  </div>
  
</template>

<script setup>
import { ref } from 'vue'
import paquetesData from '@/assets/data/paquetes.json'
import MitikuinSecccionOne from '@/components/MitikuinSecccionOne.vue'
import MitiWhatsapp from '@/components/MitiWhatsapp.vue'
import MitiFooter from '@/components/MitiFooter.vue'
import MitiPortfolio from '@/components/MitiPortfolio.vue'



// 📦 Ref con los datos del JSON
const paquetes = ref(paquetesData)

</script>

<style scoped>
/* ===== Design tokens & fonts ===== */
:root {
  --tech-cyan: #00e5ff;
  --tech-cyan-2: #38f9ff;
  --tech-blue: #0a2a43;
  --tech-deep: #081822;
  --text-strong: #e9f7ff;
  --text-contrast: #cfe7ff;
}

/* Margen especial para LinkedIn */
.footer-social .linkedin-icon {
  padding-left: 8px;
  padding-right: 8px;
}

@media (max-width: 768px) {
  .footer-social .linkedin-icon {
    padding-right: 18px; /* más separación en móvil */
  }
}

.card-body,
.card-footer {
  padding: 1.8rem;
  background-color: #001933;
  font-family: 'Satoshi', sans-serif !important;
}

.card-footer {
  padding-top: 0;
  padding-bottom: 1.5rem;
}

.card-glass {
  background: rgba(255, 255, 255, 0.06);
  border: 1px solid rgba(255, 255, 255, 0.12);
  backdrop-filter: blur(10px);
  border-radius: 1rem;
}

.card-electric {
  border: 2px solid #001933 transparent;
  border-radius: 1em;
  position: relative;
  background-clip: padding-box;
}

.card-electric::before {
  content: "";
  position: absolute;
  inset: -2px;
  border-radius: 1em;
  z-index: -1;
  background: conic-gradient(from 180deg, var(--tech-cyan), var(--tech-cyan-2), var(--tech-cyan));
  background-size: 200% 200%;
  animation: electric-border 6s linear infinite;
  filter: blur(1px);
}

.intro-text,
.intro-text1 {
  color: #ffffffcb;
  max-width: 800px;
  margin: 0 auto;
  font-family: 'Satoshi', sans-serif !important;
}

.intro-text1 {
  font-weight: bold;
  font-size: 2rem !important;
}

.card-subtitle1 {
  color: #a8ff78 !important;
  font-weight: bold;
  font-size: 1rem;
  margin-top: 0.5rem;
}

.tagline {
  color: #b7dfff;
}

.price {
  color: #00e5ff;
  font-size: 1.1rem;
}

.titlepaq {
  width: 82%;
}

.featurestitle {
  color: #cfe7ff;
}

.textdescription,
.textdescription2 {
  font-family: 'Satoshi' !important;
  font-weight: bold !important;
  color: #fefefe !important;
}

.textdescription {
  font-size: 1.2rem;
}

.textdescription2 {
  font-size: 1.6rem;
  text-align: center !important;
}

.mockupdown1 {
  margin: 0 0 0 auto !important;
  opacity: 0.4 !important;
}
</style>
